const styles = (theme) => {
  const isDark = theme.palette.mode === "dark";

  return {
    pageWrapper: {
      padding: "0",
      minHeight: "calc(100vh - 100px)",
    },

    // ── Control Bar ──
    controlBar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: "12px",
      marginBottom: "24px",
      padding: "16px 20px",
      background: isDark
        ? "linear-gradient(135deg, #1a1d23 0%, #23272f 100%)"
        : "#fff",
      borderRadius: "14px",
      border: isDark ? "1px solid rgba(255,255,255,0.06)" : "1px solid rgba(0,0,0,0.08)",
      boxShadow: isDark ? "none" : "0 2px 8px rgba(0,0,0,0.04)",
    },
    periodPills: {
      display: "flex",
      gap: "6px",
      flexWrap: "wrap",
    },
    pill: {
      padding: "7px 18px",
      borderRadius: "20px",
      border: isDark ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.15)",
      background: "transparent",
      color: isDark ? "rgba(255,255,255,0.55)" : "rgba(0,0,0,0.55)",
      cursor: "pointer",
      fontSize: "13px",
      fontWeight: 500,
      transition: "all 0.2s ease",
      "&:hover": {
        background: "rgba(99,102,241,0.12)",
        borderColor: "rgba(99,102,241,0.3)",
        color: "#818cf8",
      },
    },
    pillActive: {
      background: "linear-gradient(135deg, #6366f1 0%, #818cf8 100%)",
      border: "1px solid #6366f1",
      color: "#fff",
      "&:hover": {
        background: "linear-gradient(135deg, #6366f1 0%, #818cf8 100%)",
        color: "#fff",
      },
    },
    refreshBtn: {
      padding: "8px 20px",
      borderRadius: "10px",
      border: "1px solid rgba(99,102,241,0.3)",
      background: "rgba(99,102,241,0.08)",
      color: "#818cf8",
      cursor: "pointer",
      fontSize: "13px",
      fontWeight: 600,
      display: "flex",
      alignItems: "center",
      gap: "6px",
      transition: "all 0.2s ease",
      "&:hover": {
        background: "rgba(99,102,241,0.18)",
      },
    },
    inputField: {
      background: isDark ? "rgba(255,255,255,0.05)" : "#fff",
      border: isDark ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.2)",
      color: isDark ? "#fff" : "#333",
      padding: "6px 12px",
      borderRadius: "8px",
      outline: "none",
      "&:focus": {
        borderColor: "#6366f1",
        boxShadow: "0 0 0 2px rgba(99,102,241,0.2)",
      },
      "& option": {
        background: isDark ? "#1e2128" : "#fff",
        color: isDark ? "#fff" : "#333",
      },
    },

    // ── Section Title ──
    sectionHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "16px",
    },
    sectionTitle: {
      fontSize: "18px",
      fontWeight: 700,
      color: isDark ? "#fff" : "#111827",
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    sectionSubtitle: {
      fontSize: "12px",
      color: isDark ? "rgba(255,255,255,0.5)" : "rgba(0,0,0,0.5)",
      marginTop: "2px",
    },

    // ── KPI Grids ──
    kpiGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
      gap: "16px",
      marginBottom: "28px",
    },
    cohortGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: "16px",
      marginBottom: "28px",
    },

    // ── Branch Health Summary ──
    branchHealthGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
      gap: "16px",
      marginBottom: "28px",
    },
    healthCard: {
      background: isDark
        ? "linear-gradient(145deg, #1e2128 0%, #262a33 100%)"
        : "#fff",
      borderRadius: "14px",
      padding: "20px",
      border: isDark ? "1px solid rgba(255,255,255,0.06)" : "1px solid rgba(0,0,0,0.08)",
      boxShadow: isDark ? "none" : "0 4px 6px -1px rgba(0,0,0,0.05)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      position: "relative",
      overflow: "hidden",
    },
    healthIndicator: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "4px",
    },
    statusActive: {
      backgroundColor: "#3b82f6",
    },
    statusPartial: {
      backgroundColor: "#f59e0b",
    },
    statusInactive: {
      backgroundColor: "#6b7280",
    },

    // ── Interactive Map Banner Card ──
    mapPromoCard: {
      background: isDark
        ? "linear-gradient(135deg, #1e2128 0%, #2a2238 100%)"
        : "linear-gradient(135deg, #eef2ff 0%, #f5f3ff 100%)",
      borderRadius: "16px",
      padding: "24px 28px",
      border: isDark ? "1px solid rgba(99,102,241,0.2)" : "1px solid rgba(99,102,241,0.25)",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: "20px",
      marginBottom: "28px",
      boxShadow: isDark ? "none" : "0 4px 12px rgba(99,102,241,0.08)",
    },
    mapPromoBtn: {
      padding: "10px 24px",
      borderRadius: "10px",
      background: "linear-gradient(135deg, #6366f1 0%, #818cf8 100%)",
      color: "#fff",
      border: "none",
      fontWeight: 600,
      fontSize: "14px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      transition: "all 0.2s ease",
      "&:hover": {
        transform: "translateY(-1px)",
        boxShadow: "0 4px 12px rgba(99,102,241,0.35)",
      },
    },

    // ── Metadata Banner ──
    metaBanner: {
      background: "rgba(99,102,241,0.05)",
      border: "1px solid rgba(99,102,241,0.2)",
      borderRadius: "10px",
      padding: "12px 16px",
      marginBottom: "24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: "12px",
      fontSize: "12px",
      color: isDark ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
    },
    metaInfo: {
      display: "flex",
      alignItems: "center",
      gap: "16px",
    },
    metaWarning: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      color: "#fbbf24",
      background: "rgba(251,191,36,0.1)",
      padding: "4px 10px",
      borderRadius: "6px",
    },

    // ── Loading ──
    loadingOverlay: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "400px",
      color: isDark ? "rgba(255,255,255,0.4)" : "rgba(0,0,0,0.4)",
      fontSize: "15px",
    },
  };
};

export default styles;
